module.exports = __webpack_public_path__ + "static/media/fruit_jesus_5.b7ab3f81.jpeg";